import axios from '../../../../utils/request';

function GET_LIST(params) {
    return axios.get("/member/AServer/index",{
        params: {
            page:params
        }
    } )
}

function SUBMIT_ADD(params) {
    return  axios.post("/member/AServer/addPost",{...params} )
}
function EDIT_DATA(params) {
    return  axios.get("/member/AServer/edit",{
        params: {
           id:params
        }
    } )
}
function SUBMIT_EDIT(params) {
    return  axios.post("/member/AServer/editPost",{...params} )
}
function CHANG_STATUS (params) {
    return  axios.post("/member/AServer/statusEdit",{status:params} )
}
function DELE(params) {
    return  axios.get("/member/AServer/delete",{
        params: {
            ids:params
        }
    } )
}


export default {
    GET_LIST,
    SUBMIT_ADD,
    EDIT_DATA,
    SUBMIT_EDIT,
    CHANG_STATUS,
    DELE,


};